import { Axios } from "@/utils/axios";

export type FlowerOrderRequestBody = {
  item_name: string;
  total_amount: number;
  item_thumbnail_url: string;
  left_sentence: string;
  right_sentence: string;

  email: string;
  name: string;
  /** 010-1234-5678*/
  phone: string;
  base_address: string;
  address_detail: string;
  recipient_name: string;
  recipient_phone?: string;
  requirements?: string;
  /** parlor_id */
  parlor?: string;
};

/** 모든 필드 암호화되어 있는 상태 */
export type FlowerOrderResponse = {
  order_id: string;
  app_ver: string;
  company_name: string;
  item_name: string;
  total_amount: string;
  requirements: string;
  recipient_name: string;
  recipient_phone: string;
  item_url: string;
  order_name: string;
  order_phone: string;
  order_email: string;
  address_1: string;
  address_2: string;
  key_word_left: string;
  key_word_right: string;
};

export const postWreathOrder = async (body: FlowerOrderRequestBody) => {
  const { data } = await Axios.post<FlowerOrderResponse>(`/wreath_orders/`, body);

  return data;
};

type WreathOrderPaymentMethod = "카드" | "가상계좌" | "간편결제" | string;
type WreathOrderStatus =
  /** 유효시간 만료 */
  | "EXPIRED"
  /** 승인 실패 */
  | "ABORTED"
  /** 가상계좌 발급된 상태 */
  | "WAITING_FOR_DEPOSIT"
  /** 결제 완료 */
  | "DONE"
  /** 취소 */
  | "CANCELED"
  /** 취소 */
  | "PARTIAL_CANCELED";

type FlowerOrderStatusResponse = {
  payment: {
    status: WreathOrderStatus;
    method: WreathOrderPaymentMethod;
  };
};

export const postWreathOrderStatus = async (orderId: string) => {
  const { data } = await Axios.post<FlowerOrderStatusResponse>(`/wreath_orders/search/`, {
    order_id: orderId,
  });

  return data;
};
